export default "__VITE_ASSET__BYi6CBvn__"